import { Accordion, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconSettings } from "@tabler/icons-react";
import NewsletterAdvancedSettings from "./NewsletterAdvancedSettings";
import { useLanguage } from "../../../stores/LanguageStore";

const NewsletterAdditionals = () => {
  const lang = useLanguage((s) => s.language);
  return (
    <Accordion variant="contained" bg={"#fff"} radius={"xl"} mt={"md"}>
      <Accordion.Item value="list">
        <Accordion.Control>
          <Group>
            <ThemeIcon variant="light" size={"xl"} radius={"xl"} color="gray">
              <IconSettings />
            </ThemeIcon>
            <Stack gap={0}>
              <Text>{lang.import_contacts.linkedin.more_options}</Text>
            </Stack>
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          <NewsletterAdvancedSettings />
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default NewsletterAdditionals;
